var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScatteredClouds(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 13.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_part_I",
    "data-name": "icons part I"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.5,13.6H4.7c-2.6,0-4.7-2.1-4.7-4.7,0-2.2,1.5-4,3.5-4.6C3.8,1.8,6,0,8.5,0c1.3,0,2.6.5,3.5,1.5,1.5-.9,3.5-.5,4.5,1,.3.6.5,1.2.5,1.8v.2c2.4.9,3.6,3.6,2.7,6.1-.6,1.7-2.1,2.8-3.9,3h-.3ZM8.5,2c-1.7,0-3,1.3-3,3v.1c0,.5-.4,1-.9,1-1.5.1-2.6,1.3-2.6,2.8.1,1.6,1.3,2.7,2.7,2.7h10.7c1.5-.1,2.6-1.3,2.6-2.8-.1-1.3-1.1-2.4-2.3-2.5-.5-.1-.9-.6-.9-1.1,0-.1,0-.2.1-.3.1-.3.1-.4.1-.6,0-.7-.6-1.2-1.2-1.2-.4,0-.8.2-1,.5s-.5.4-.9.4c-.3,0-.6-.2-.8-.5-.6-.9-1.5-1.5-2.6-1.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatteredClouds);
export default __webpack_public_path__ + "static/media/scattered_clouds.276d71d266a5123cbea71548b7c0da21.svg";
export { ForwardRef as ReactComponent };